import { render, staticRenderFns } from "./ProgressChart.vue?vue&type=template&id=c2af6990&scoped=true&"
import script from "./ProgressChart.vue?vue&type=script&lang=js&"
export * from "./ProgressChart.vue?vue&type=script&lang=js&"
import style0 from "./ProgressChart.vue?vue&type=style&index=0&id=c2af6990&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2af6990",
  null
  
)

export default component.exports